import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedCurrency'
})
export class LocalizedCurrencyPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private currencyPipe: CurrencyPipe,
  ) { }

  transform(value: any, currencyCode: string = 'EUR', display: 'symbol' | 'code' | boolean = 'symbol', digitsInfo: string = '1.2-2'): any {
    const currentLang = this.translate.currentLang;

    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, currentLang);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/pipes/localized-currency.pipe.ts